import {PackingSlipTemplateKind} from 'src/interfaces/PackingSlipTemplate.interface'

type Props = {
  value: PackingSlipTemplateKind
  onChange: (kind: PackingSlipTemplateKind) => void
}

const PackingSlipTemplateTypeSelector = ({value, onChange}: Props) => {
  const isStandard = value === 'standard'
  const isCustom = value === 'custom'

  return (
    <fieldset className='packing-slip-template-type'>
      <legend className='packing-slip-template-type__legend'>Template Type</legend>

      <div className='packing-slip-template-type__options'>
        <label
          className={`packing-slip-template-type__card ${isStandard ? 'is-selected' : ''}`}
        >
          <input
            type='radio'
            name='packing-slip-template-type'
            className='packing-slip-template-type__radio'
            checked={isStandard}
            onChange={() => onChange('standard')}
          />
          <span className='packing-slip-template-type__title-row'>
            <span className='packing-slip-template-type__title'>Standard</span>
          </span>
          <span className='packing-slip-template-type__description'>
            Built-in layout. Toggle which details appear.
          </span>
        </label>

        <label
          className={`packing-slip-template-type__card ${isCustom ? 'is-selected' : ''}`}
        >
          <input
            type='radio'
            name='packing-slip-template-type'
            className='packing-slip-template-type__radio'
            checked={isCustom}
            onChange={() => onChange('custom')}
          />
          <span className='packing-slip-template-type__title-row'>
            <span className='packing-slip-template-type__title'>Use your own design</span>
            <span className='packing-slip-template-type__badge'>For retailers</span>
          </span>
          <span className='packing-slip-template-type__description'>
            When a buyer requires their own packing slip format. Add the HTML file they sent and
            we fill in each order&apos;s details.
          </span>
        </label>
      </div>
    </fieldset>
  )
}

export default PackingSlipTemplateTypeSelector
